/**
 * Money entry for the sales forms.
 *
 * The model stores cents, the field shows euros - nobody types a price in
 * cents, and rounding once on the way in is what keeps a line total from
 * drifting a cent away from the invoice total.
 */

/** Cents to what the field shows: always two decimals, so 1200 reads "12.00". */
export function centsToInput(cents: number): string {
  return (cents / 100).toFixed(2);
}

/**
 * What the field shows back to cents. The comma is accepted as well as the dot:
 * an Estonian keyboard writes "12,50" and the numeric keypad has no dot on it.
 * Anything unparseable is 0 rather than NaN, which would poison every total
 * downstream.
 */
export function inputToCents(s: string): number {
  const n = parseFloat(s.replace(",", "."));
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}
